import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Spinner } from "@/components/ui/spinner";

type RunQueryProgressModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  progress:
    | { kind: "single" }
    | { kind: "run-group"; completedCount: number; expectedCount: number };
};

export function RunQueryProgressModal({ open, onOpenChange, progress }: RunQueryProgressModalProps) {
  const isRunGroup = progress.kind === "run-group";
  const statusMessage = isRunGroup
    ? `Completed ${progress.completedCount} of ${progress.expectedCount} runs.`
    : "Running evaluation.";
  const helperMessage = isRunGroup
    ? "We’re aggregating repeat runs and will show the averaged results when every run finishes."
    : "We’ll open the result brief automatically as soon as the model response is ready.";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md text-center" aria-describedby="run-query-progress-description">
        <DialogHeader className="mb-5 text-left">
          <DialogTitle>Running query</DialogTitle>
          <DialogDescription id="run-query-progress-description">
            Please keep this page open while the evaluation finishes.
          </DialogDescription>
        </DialogHeader>

        <div role="status" aria-live="polite" className="space-y-4">
          <Spinner className="py-4" size="lg" />
          <div>
            <p className="text-sm font-semibold text-brand-950">{statusMessage}</p>
            <p className="mt-1 text-[13px] leading-relaxed text-slate-500">{helperMessage}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
